export default "__VITE_ASSET__f13dd7e7__"